import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['radio', 'rejectionReason']

  toggle() {
    const rejectedRadio = this.radioTargets.find(r => r.value === 'rejected')

    if (rejectedRadio && rejectedRadio.checked) {
      this.rejectionReasonTarget.classList.remove('d-none')
    } else {
      this.rejectionReasonTarget.classList.add('d-none')
    }
  }
}
